import React, { useState, useEffect } from "react";
import axios from "axios";
import "./DescriptionBox.css";

const StarRating = ({ rating, setRating, hoverRating, setHoverRating }) => {
  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          type="button"
          key={star}
          className={star <= (hoverRating || rating) ? "on" : "off"}
          onClick={() => setRating(star)}
          onMouseEnter={() => setHoverRating(star)}
          onMouseLeave={() => setHoverRating(0)}
        >
          <span className="star">★</span>
        </button>
      ))}
    </div>
  );
};

const DescriptionBox = ({ productId }) => {
  const [reviews, setReviews] = useState([]);
  const [newReview, setNewReview] = useState({ name: "", rating: 0, comment: "" });
  const [hoverRating, setHoverRating] = useState(0);

  
  useEffect(() => {
    const fetchReviews = async () => {
      if (!productId) return;
      try {
        // --- CORRECTED GET URL ---
        const response = await axios.get(`/api/products/${productId}/reviews`);
        setReviews(response.data);
      } catch (error) {
        console.error("Failed to fetch reviews", error);
      }
    };
    fetchReviews();
  }, [productId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewReview((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitReview = async (e) => {
    e.preventDefault();
    if (newReview.rating === 0 || !newReview.comment || !newReview.name) {
      alert("Please fill out your name, a rating, and a comment.");
      return;
    }
    try {
      const response = await axios.post(`/api/products/${productId}/reviews`, {
        name: newReview.name,
        rating: newReview.rating,
        comment: newReview.comment,
      });

      if (response.data.success) {
        setReviews([response.data.review, ...reviews]);
        setNewReview({ name: "", rating: 0, comment: "" });
      }
    } catch (error) { // --- THIS BLOCK IS NOW CORRECTED ---
      console.error("Failed to submit review", error);
      alert("There was an error submitting your review.");
    }
  };
  
  return (
    <div className="description-box container">
      <div className="description-box__navigator">
        <div className="description-box__nav-button active">
          Customer Reviews ({reviews.length})
        </div>
      </div>

      <div className="description-box__content">
        <form className="review-form" onSubmit={handleSubmitReview}>
          <h3>Leave a Review</h3>
          <p className="review-form__prompt">Share your thoughts with other customers</p>
          <div className="form-group">
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Your Name"
              value={newReview.name}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group rating-group">
             <label>Your Rating</label>
            <StarRating
              rating={newReview.rating}
              setRating={(rating) => setNewReview({ ...newReview, rating })}
              hoverRating={hoverRating}
              setHoverRating={setHoverRating}
            />
          </div>
          <div className="form-group">
            <textarea
              id="comment"
              name="comment"
              rows="5"
              placeholder="Write your review here..."
              value={newReview.comment}
              onChange={handleInputChange}
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-review-btn">
            Submit Review
          </button>
        </form>

        <hr className="review-divider" />

        <div className="review-list">
          {reviews.length > 0 ? (
            reviews.map((review) => (
              <div key={review._id} className="review-item">
                <div className="review-item__header">
                  <strong className="review-item__name">{review.name}</strong>
                  <div className="review-item__stars">
                    {"★".repeat(review.rating)}
                    {"☆".repeat(5 - review.rating)}
                  </div>
                </div>
                <p className="review-item__comment">{review.comment}</p>
                <small className="review-item__date">
                  {new Date(review.createdAt).toLocaleDateString()}
                </small>
              </div>
            ))
          ) : (
            <p className="no-reviews-text">Be the first to share your thoughts!</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DescriptionBox;